module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "chap2",
      "src": "images/chap2.jpg"
    }
  })])]), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("CAN YOU UNDERSTAND ME?")])]), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "tortue_1",
      "src": "images/tortue.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "mev1"
  }, [_c('b', [_vm._v("TWO YEARS AGO,")])]), _vm._v(" Sandra Oh became the first-ever Asian to be nominated for an Emmy Award as Lead Actress in a Drama Series. Oh’s visibility and representation produced a groundswell of joy and pride among Asians. We rallied together to celebrate and giddily reveled in the movement as it flowed across the nation. It felt for a moment that our contributions as Asian Americans, our personhood, our stories, and our work were being seen and valued on one of the greatest platforms in the world. For me, a Korean woman like Oh, this moment felt even more specifically and directly meaningful.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Oh said something during the awards season that struck me. As she sat next to her mom at the Emmys ceremony, she said, “It’s an honor just to be Asian.”")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("It’s an honor just to be Asian.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As a Four, one of my core longings and motivations is to be understood. However, my journey as a person of color living out two cultural identities compounds this innate "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("longing. As an Asian American in this country, there are two dominant narratives our community is constantly pushing up against. We are perceived as either the "), _c('i', [_vm._v("perpetual foreigner")]), _vm._v(" or the "), _c('i', [_vm._v("model minority")]), _vm._v(". A "), _c('i', [_vm._v("perpetual")]), _vm._v(" or "), _c('i', [_vm._v("forever")]), _vm._v(" foreigner is someone who does not belong in America, could never be born here, and does not have the right to call the United States their home. An example of this is being asked at the grocery store, “Can you speak English? "), _c('i', [_vm._v("Can you understand me?")]), _vm._v("” The term "), _c('i', [_vm._v("model minority")]), _vm._v(" is a myth constructed by white supremacy to pit Asians against other racial groups, claiming that we naturally succeed and have somehow overcome racism through diligence and hard work. These two themes often leave us feeling generalized, diminished, and invisible.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For the majority of my life, I tried to respond to these walls of invisibility by assimilating into dominant contexts and muting my Koreanness. What I didn’t realize was that in my efforts to live this way, I was not only perpetuating my people’s invisibility—I was actively erasing myself, my family, and my people. My Four core need to be understood could never be met by a society resolute on diminishing and erasing my people’s history and humanity.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Along my Enneagram journey, I found great comfort in the story of Hagar in the Scriptures. Hagar is an enslaved Egyptian woman who is victimized, marginalized, and deeply misunderstood. In her dual oppression, she is not "), _c('i', [_vm._v("seen ")]), _vm._v("in her context. Hagar is impregnated by her owner, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("Abram, and subsequently experiences the devastating loss of her home and community. In Genesis 16, Hagar flees into the desert, and in this moment of great vulnerability, God pursues her. God seeks to understand her and asks, “Where have you come from, and where are you going?” As Hagar engages God, she becomes the first person in the Bible to name God. She calls out to God as “El Roi, the God who sees me.”")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In my longing as a Four to be understood, I wonder to myself how I, like Hagar, can be set free from societal narratives that claim I can be only a model minority or a perpetual foreigner. Instead of yielding to these portrayals by the dominant culture, how can I show up fully in the unique way I’ve been created? God is the God who sees, but I am also a part of making God visible to the world.")]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("As a Korean American woman, my story is connected to generations of ancestors before me who also resisted narratives meant to perpetuate self-hatred in people of color. My story is woven into the fabric of my Asian American sisters, mothers, daughters, and grandmothers who reclaimed their dignity in the face of oppression. I no longer see my Koreanness as something to be hidden, diminished, or erased but am learning to stand fully on the sacred and holy ground of being an Asian American woman. I bear the extraordinary image of God, and in choosing to embrace where I’ve come from and where I am going, I can’t help but feel these same words: “It’s an honor just to be Asian.”")]), _c('div', {
    staticClass: "encfond",
    attrs: {
      "id": "enc-002"
    }
  }, [_c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Reflect on your story and the intersectional identities you hold. What does it mean to you that God is El Roi, the God who sees you? ")])])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("If you are a Four and experience a desire to be understood, what does it mean that you make God visible to the world? ")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre"
  }, [_c('b', [_vm._v("Take some time to respond to the question that God asks Hagar: “Where have you come from, and where are you going?”")])]), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "response"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5d1248","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap2.vue
// module id = 75
// module chunks = 0